import router from './../../router'
import 'clientjs'
import murmurHash3 from 'murmurhash3js'
import qs from 'qs'

class Repetitive {
    Name_app = "Covid";
    constructor(TK, IMEI, id_login) {
        this.TK = TK,
        this.IMEI = IMEI,
        this.id_login = id_login
    }
}

const state = {
    form: {
        login: '',
        password: '',
        IMEI: null
    }  
}

const getters = {
    getIngot: (state) => {
        const client = new ClientJS();
        const fingerprint = client.getFingerprint();
        const IMEI = murmurHash3.x64.hash128(fingerprint.toString())
        return `Covid_${IMEI}`
    },
    signInparams: (state) => {
        return JSON.stringify({
            Name_app: "Covid",
            IMEI: state.form.IMEI,
            login: state.form.login,
            password: state.form.password
        })
    },
    greetingParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module:"WEB_division",
            Name_event: 'hello_event'
        }))
    }

}


const mutations = {
    UPDATE_LOGIN (state, payload) { 
        state.form.login = payload;
    },
    UPDATE_PASSWORD (state, payload) {
        state.form.password = payload;
    },
    FINGERPRINT (state, payload) {
        state.form.IMEI = payload;
    }
}

const actions = {
    updateLogin({ commit }, context) {
        commit('UPDATE_LOGIN', context)
    },
    updatePassword({ commit }, context) {
        commit('UPDATE_PASSWORD', context)
    },

    endSession({ commit }) {
        commit('END_SESSION', 0, { root: true })
        router.push({ name: 'stop-covid' })
    },


    greeting: async({ commit, state, getters }) => {
        let greetingParams = getters.greetingParams;
        let greetingResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${greetingParams}`);
        if (greetingResponse.status >= 200 && greetingResponse.status < 300) {
            commit('GREETING', await greetingResponse.json(), { root: true }) 
        }
    },

    
    signIn: async ({ commit, state, dispatch, getters, rootState }) => {
        commit('FINGERPRINT', getters.getIngot);
        try {
            commit('PROCESSING', true, { root: true })
            let signInResponse = await fetch(`https://host2.medsafe.tech/api/login`, {
                method: "POST", 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.signInparams
                })
            })
            if (signInResponse.status >= 200 && signInResponse.status < 300)  {
                commit('USER_DATA', await signInResponse.json(), { root: true });
            }
            if (rootState.userData.hasOwnProperty('TK') && rootState.userData.TK) {
                commit('UPDATE_CHECK', true, { root: true });
                commit('SET_DEFAULT_PARAMS', new Repetitive(rootState.userData.TK, rootState.login.form.IMEI, rootState.userData.id_login), { root: true })
                await dispatch('greeting');
                commit('UPDATE_LOGIN', '');
                commit('UPDATE_PASSWORD', '');
                commit('PROCESSING', false, { root: true });
                router.push({ name: 'dashboard', params: { id_login: rootState.userData.id_login }})
            } else {
                commit('PROCESSING', false, { root: true });
                commit('UPDATE_CHECK', false);
            }         
        } catch(err) { err => console.error(`Ошибка исполнения signIn: ${err}`) }
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/login.js